import { NmvsMenuItem, nmvsMenuOperations, menuOperations } from 'types/nmvs-menu-item';

export const initialState: MenuState = {
  currentOperation: nmvsMenuOperations.verify,
  operations: menuOperations,
  mobileMenuVisible: false
};

export interface MenuState {
  currentOperation: NmvsMenuItem;
  operations: NmvsMenuItem[];
  mobileMenuVisible: boolean;
}


// WEBPACK FOOTER //
// ./src/components/menu/state.ts